import React from 'react';
//ButtonBarForPatientSummary.js

const ButtonBarForPatientSummary = (props) => {
  const chartType = props.chartType; //monthly or daily
  const onChartTypeChanged = props.onChartTypeChanged;
  const t = props.t;

  const onSelected = (chartType) => {
    if (onChartTypeChanged instanceof Function) {
      onChartTypeChanged(chartType);
    }
  };

  //TODO: แก้ text
  return (
    <nav className='flex ml-0 md:ml-9 lg:ml-9 xl:ml-9'>
      <ButtonBarForPatientSummaryItem
        onSelected={onSelected}
        selected={chartType === 'monthly' ? true : false}
        title={t('patient_summary_monthly')}
        value='monthly'
        roundSide='l'
      />
      <ButtonBarForPatientSummaryItem
        onSelected={onSelected}
        selected={chartType === 'daily' ? true : false}
        title={t('patient_summary_daily')}
        value='daily'
        roundSide='r'
      />
    </nav>
  );
};

export const ButtonBarChartOrTable = (props) => {
  const isShowTableView = props.isShowTableView;
  const onIsShowTableChanged = props.onIsShowTableChanged;

  const onSelected = (viewType) => {
    if (onIsShowTableChanged instanceof Function) {
      let isShowTable = false;
      if (viewType === 'table') {
        isShowTable = true;
      }
      onIsShowTableChanged(isShowTable);
    }
  };

  //TODO: แก้ text
  return (
    <nav className='flex ml-0 md:ml-9 lg:ml-9 xl:ml-9'>
      <ButtonBarForPatientSummaryItem
        onSelected={onSelected}
        selected={isShowTableView ? false : true}
        title={'Chart'}
        value='chart'
        roundSide='l'
      />
      <ButtonBarForPatientSummaryItem
        onSelected={onSelected}
        selected={isShowTableView ? true : false}
        title={'Table'}
        value='table'
        roundSide='r'
      />
    </nav>
  );
};

const ButtonBarForPatientSummaryItem = (props) => {
  const roundSide = props.roundSide; //r = right or l = left
  const selected = props.selected;
  const value = props.value;
  const title = props.title;
  const onSelected = props.onSelected;

  let className = selected
    ? 'flex items-center justify-center w-30 h-9 text-lg font-normal tracking-wide text-center no-underline capitalize border border-green-gray hover:text-summary-header text-summary-header bg-green'
    : 'flex items-center justify-center w-30 h-9 text-lg font-normal tracking-wide text-center no-underline capitalize border border-green-gray hover:text-summary-header text-summary-header';
  if (roundSide) {
    className += ' rounded-' + roundSide;
  }

  return (
    <div className={className} onClick={() => onSelected(value)}>
      {title}
    </div>
  );
};

export default ButtonBarForPatientSummary;
